'use strict';

var ChartExportOptionsView = Backbone.Marionette.ItemView.extend({
    events: {
        'click #js-chart-export-submit': function () {
            this.onSubmit(this.ui.edtName.val());
        },
        'input .js-custom-label': function () {
            this.validate();
        },
    },
    ui: {
        edtName: '.js-custom-label',
        btnOK: '#js-chart-export-submit',
    },
    initialize: function (data) {
        this.onSubmit = data.onSubmit;
    },
    template: require('components/devices/templates/common/chart_export_options'),
    serializeData: function () {
        var data = Backbone.Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.caption = this.options.caption;
        return data;
    },
    onShow: function () {
        var self = this;
        setTimeout(function () {
            self.ui.edtName.focus();
            self.ui.edtName.select();
        }, 220);
    },
    validate: function () {
        this.ui.btnOK.prop('disabled', this.ui.edtName.val() == '');
    },
});

module.exports = ChartExportOptionsView;
